import Vue from 'vue';
import vuex from 'vuex';
import axios from 'axios';
Vue.use(vuex)

export default new vuex.Store({
	state: {
		allData: '',
		languagesData: '',
		highlight: 'index'
	},
	mutations: {
		languagesDataFun(state, data) {
			state.allData = data.data.data;
			state.languagesData = data.data.data.english;
		},
		changeLanguage(state, language) {
			console.log(language);
			state.languagesData = state.allData[language];
		}
	},
	getters: {},
	actions: {
		getData(type) {
			console.log(type);
			return new Promise(resolve => {
				axios.get('./static/language.json').then(res => {
					console.log(res);
					this.commit("languagesDataFun", res);
					resolve(res)
				})
			})
		}
	},
	modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js